import styled from 'styled-components'
import SolidLockAltIcon from 'LuxKit/Icons/solid/SolidLockAltIcon'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  display: grid;
  place-items: center;
  backdrop-filter: blur(12px);

  body.${REBRAND_PALETTE_CLASS} & {
    border-radius: var(--border-radius-m);
    overflow: hidden;
  }
`

const StyledSolidLockAltIcon = styled(SolidLockAltIcon)`
  color: var(--palette-neutral-surface-dark-contrast);
`

function LuxPlusHiddenOfferImageOverlay() {
  return <Overlay><StyledSolidLockAltIcon size="XL" /></Overlay>
}

export default LuxPlusHiddenOfferImageOverlay
